/*------------------------------------------------------------------*\
	Cycles example questions through the landing search field while
	it sits idle and empty. Stops on focus, resumes on blur only if
	nothing was typed (or whatever was typed has been deleted).
\*------------------------------------------------------------------*/

ThemeJS.Landing_Search_Placeholder = (function ($) {

	const FORM_SELECTOR = '.landing-search-form[data-placeholders]';
	const HOLD_DURATION = 3500; // ms each example stays fully visible
	const FADE_DURATION = 400;  // keep in sync with --placeholder-fade in _landing-search-form.scss

	function get_examples($form) {
		let examples = $form.data('placeholders');

		if (typeof examples === 'string') {
			try {
				examples = JSON.parse(examples);
			} catch (error) {
				examples = [];
			}
		}

		if (!Array.isArray(examples)) {
			return [];
		}

		return examples.filter(function (text) {
			return typeof text === 'string' && text.trim() !== '';
		});
	}

	function setup(form) {
		const $form = $(form);
		const $input = $form.find('input[type="search"]').first();
		const $text = $form.find('.landing-search-form__placeholder-text').first();
		const examples = get_examples($form);

		if (!$input.length || !$text.length || examples.length < 2) {
			return;
		}

		let index = 0;
		let timer = null;
		let cycling = false;

		function is_empty() {
			return $input.val().trim() === '';
		}

		function schedule_next() {
			clearTimeout(timer);
			timer = setTimeout(rotate, HOLD_DURATION);
		}

		function show(text) {
			$text.text(text).removeClass('is-leaving').addClass('is-entering');
			// Two frames so the start position below the line paints before it rises.
			requestAnimationFrame(function () {
				requestAnimationFrame(function () {
					if (!cycling) {
						return;
					}
					$text.removeClass('is-entering');
					schedule_next();
				});
			});
		}

		function rotate() {
			if (!cycling) {
				return;
			}

			$text.addClass('is-leaving');

			timer = setTimeout(function () {
				if (!cycling) {
					return;
				}
				index = (index + 1) % examples.length;
				show(examples[index]);
			}, FADE_DURATION);
		}

		function start() {
			if (cycling || !is_empty()) {
				return;
			}
			cycling = true;
			$form.addClass('is-cycling-placeholder');
			show(examples[index]);
		}

		function stop() {
			cycling = false;
			clearTimeout(timer);
			$form.removeClass('is-cycling-placeholder');
			$text.removeClass('is-leaving is-entering');
		}

		$input.on('focus', stop);

		$input.on('blur', function () {
			if (is_empty()) {
				start();
			}
		});

		$input.on('input', function () {
			if (!is_empty()) {
				stop();
			}
		});

		if (!$input.is(':focus')) {
			start();
		}
	}

	function init(root) {
		const $root = root ? $(root) : $(document);
		$root.find(FORM_SELECTOR).addBack(FORM_SELECTOR).each(function () {
			setup(this);
		});
	}

	$(function () {
		init();
	});

	return {
		init,
	};

})(jQuery);
